export function valueByKey(obj, k, d) {
    d = d !== undefined ? d : ''
    return obj && obj[k] ? obj[k] : d
}
